import axios from 'axios';
import { AppConfig } from "@/constants";

// Function to fetch all users
async function fetchAllUsers() {
  let response = {};
  let token = localStorage.getItem('access_token');
  try {
    response = await axios.get(AppConfig.API_BASE_URL + '/user/all_users', {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }});
    return response.data; // Return the user data
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

async function fetchAllQuestions() {
  let response = {};
  let token = localStorage.getItem('access_token');
  try {
    response = await axios.get(AppConfig.API_BASE_URL + '/questions/get_all_questions', {headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }});
    return response.data; // Return the user data
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
}

async function bulkUploadQuestions(selectedFile) {
      if (!selectedFile) {
        return 'Please select a file first.';
      }

      const formData = new FormData();
      formData.append('excelFile', selectedFile);

      try {
        let token = localStorage.getItem('access_token');
        const response = await axios.post(AppConfig.API_BASE_URL + '/questions/bulk_upload_questions', formData, {headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + token }});

        if (response.status === 201) {
          return 'File uploaded successfully.';
        } else {
          return 'File upload failed.';
        }
      } catch (error) {
        console.error('Error uploading file:', error);
      }
}

// Export the methods
export {
  fetchAllUsers,
  fetchAllQuestions,
  bulkUploadQuestions
};